module.exports = __webpack_public_path__ + "img/Hugh_Hodgson_School_of_Music_-_PE-t-22048-011.77c98d75.jpg";